wsMain.createModule({
  name: "categorias",
  onlyAfter: "info-lojas",
  function: "get",
  options: {
    megaMenu: true,
  },
  async get() {
    if (!document.querySelector("[data-wsjs-module=categorias]")) return;
    let data = await ApiWS.Calls.ListaCategorias();

    document
      .querySelectorAll("[data-wsjs-module=categorias]")
      .forEach((tag) => {
        wsMain.modules["categorias"].create(data, tag);
      });

    wsMain.addons.headerFirstLoad();

    return true;
  },
  create(returnJson, tag) {
    let configs = wsMain.options[this.name],
      categorias = returnJson.Categorias,
      categoriasCustom = returnJson.MenuPersonalizado;

    let options = wsMain.tools.getWsData(tag, "options");
    let text = tag.innerHTML;

    let arrCat;

    if (
      !options.atual &&
      options.custom != false &&
      Array.isArray(categoriasCustom) &&
      categoriasCustom.length > 0
    ) {
      categoriasCustom.forEach((elm) => {
        if (elm.nome.trim().toString().toLowerCase() == "categorias")
          elm.subcategorias = categorias;
      });
      arrCat = categoriasCustom;
    } else if (Array.isArray(categorias) || categorias.length > 0) {
      arrCat = categorias;
    } else {
      return;
    }
    let arrLvl = 0;
    function search(mainArr, catToSearch) {
      function searchInsideSubCat(arr, lvl = 0, parent = false) {
        let response;
        arr.forEach((cat) => {
          let subCat = searchInsideACat(cat, lvl, parent);
          response = subCat ? subCat : response;
        });

        return response;
      }

      function searchInsideACat(cat, lvl, parent) {
        if (catToSearch) {
          if (cat.id == catToSearch) return [cat, lvl, parent];
        } else {
          if (cat.atual) return [cat, lvl, parent];
        }

        if (cat.subcategorias && cat.subcategorias.length > 0)
          return searchInsideSubCat(cat.subcategorias, lvl + 1, cat);

        return;
      }

      return searchInsideSubCat(mainArr);
    }

    if (options.atual) {
      let searchResult = search(
        arrCat,
        document.querySelector("#HD_CAT_ID").value,
      );

      if (searchResult) {
        arrLvl = searchResult[1];
        arrCat = searchResult[2]
          ? searchResult[2].subcategorias
          : searchResult[0].subcategorias;

        if (arrCat.length == 0 && arrLvl != 0) {
          arrCat = searchResult[0].subcategorias || 0;
        }
      } else {
        arrCat = [];
      }
    }

    if (options.allCats || options.mobile) {
      let objToUse = {
        atual: false,
        id: "allCats-menu",
        nome: "Todos os departamentos",
        produtodestaque: false,
        subcategorias: JSON.parse(JSON.stringify(arrCat)),
      };

      if (options.allCats) arrCat.unshift(objToUse);
      if (options.mobile) arrCat = [objToUse];
    }

    let divMain = wsMain.tools.createElm({
      type: "div",
      innerHTML: text,
      attrs: {
        class: options.defaultCat == false ? "" : "nav-menu",
      },
    });

    let ulMain = wsMain.tools.createElm({
      type: "ul",
      attrs: {
        class: "nav-menu-list",
      },
    });

    let title = wsMain.tools.createElm({
      type: "div",
      attrs: {
        class: "sub-title",
      },
    });

    let subTitle = wsMain.tools.createElm("a");

    let titleLink = wsMain.tools.createElm({
      type: "div",
      innerHTML: "Voltar",
      attrs: {
        onclick: 'this.parentNode.parentNode.classList.remove("active")',
      },
    });

    title.append(subTitle);
    title.append(titleLink);

    function createTitle(div, catLink, catName) {
      let clone = div.cloneNode(true);
      clone.querySelector("a").setAttribute("href", catLink);
      clone.querySelector("a").innerHTML = catName;
      return clone;
    }

    function createPainelDuplo(catRoot, comPainelEsquerdo) {
      let painel = wsMain.tools.createElm({
        type: "div",
        attrs: {
          class:
            "nav-menu-painel dropdown" +
            (comPainelEsquerdo ? "" : " sem-esquerdo"),
        },
      });
      let painelDir = wsMain.tools.createElm({
        type: "div",
        attrs: { class: "nav-menu-painel-direito" },
      });
      let triangulo = wsMain.tools.createElm({
        type: "div",
        attrs: { class: "nav-menu-painel-triangulo" },
      });

      painel.append(triangulo);

      function resolverDpt(c) {
        if (
          c.id != "allCats-menu" &&
          c.tipo == "dpt" &&
          c.registro &&
          c.registro != 0
        ) {
          try {
            return search(returnJson.Categorias, c.registro)[0];
          } catch (err) {
            return c;
          }
        }
        return c;
      }

      /* monta separador + .painel-grupos a partir dos filhos diretos de cat */
      function criarGruposParaCat(cat) {
        let children = cat.subcategorias || [];
        if (children.length === 0) return null;

        let separador = wsMain.tools.createElm({
          type: "hr",
          attrs: { class: "painel-separador" },
        });
        let grupos = wsMain.tools.createElm({
          type: "div",
          attrs: { class: "painel-grupos" },
        });

        let temNetos = children.some(
          (x) => x.subcategorias && x.subcategorias.length > 0,
        );

        if (temNetos) {
          children.forEach((childOrig) => {
            let child = resolverDpt(childOrig);
            let grupo = wsMain.tools.createElm({
              type: "div",
              attrs: { class: "painel-grupo" },
            });
            let grupoTitulo = wsMain.tools.createElm({
              type: "a",
              innerHTML: child.nome,
              attrs: {
                href: child.url || "javascript:;",
                class: "painel-grupo-titulo",
              },
            });
            let grupoItens = wsMain.tools.createElm({
              type: "ul",
              attrs: { class: "painel-grupo-itens" },
            });
            (child.subcategorias || []).forEach((grandchildOrig) => {
              let grandchild = resolverDpt(grandchildOrig);
              let liItem = wsMain.tools.createElm({ type: "li" });
              let aItem = wsMain.tools.createElm({
                type: "a",
                innerHTML: grandchild.nome,
                attrs: { href: grandchild.url || "javascript:;" },
              });
              liItem.append(aItem);
              grupoItens.append(liItem);
            });
            grupo.append(grupoTitulo);
            grupo.append(grupoItens);
            grupos.append(grupo);
          });
        } else {
          /* lista plana - children sem netos */
          let grupo = wsMain.tools.createElm({
            type: "div",
            attrs: { class: "painel-grupo painel-grupo-plano" },
          });
          let grupoItens = wsMain.tools.createElm({
            type: "ul",
            attrs: { class: "painel-grupo-itens" },
          });
          children.forEach((childOrig) => {
            let child = resolverDpt(childOrig);
            let liItem = wsMain.tools.createElm({ type: "li" });
            let aItem = wsMain.tools.createElm({
              type: "a",
              innerHTML: child.nome,
              attrs: { href: child.url || "javascript:;" },
            });
            liItem.append(aItem);
            grupoItens.append(liItem);
          });
          grupo.append(grupoItens);
          grupos.append(grupo);
        }

        return { separador, grupos };
      }

      function criarBloco(cat, ativo, catId) {
        let bloco = wsMain.tools.createElm({
          type: "div",
          attrs: {
            class: "painel-direito-bloco" + (ativo ? " ativo" : ""),
            "data-cat-id": catId || "",
          },
        });
        let titulo = wsMain.tools.createElm({
          type: "a",
          innerHTML: cat.nome,
          attrs: {
            href: cat.url || "javascript:;",
            class: "painel-titulo",
          },
        });
        bloco.append(titulo);

        let grupos = criarGruposParaCat(cat);
        if (grupos) {
          bloco.append(grupos.separador);
          bloco.append(grupos.grupos);
        }

        return bloco;
      }

      if (comPainelEsquerdo) {
        let painelEsq = wsMain.tools.createElm({
          type: "ul",
          attrs: { class: "nav-menu-painel-esquerdo" },
        });

        const naveguePorMarcaFixa = wsMain.tools.createElm({
          type: "a",
          innerHTML: `
        <svg xmlns="http://www.w3.org/2000/svg" width="12.012" height="11.525" viewBox="0 0 12.012 11.525" style="&#10;">
        <path id="Caminho_40941" data-name="Caminho 40941" d="M1967.429,3549.086c.128-.256.2-.39.279-.429a.272.272,0,0,1,.245,0c.083.039.15.173.279.429l1.215,2.47a.545.545,0,0,0,.089.145.248.248,0,0,0,.083.067.608.608,0,0,0,.167.033l2.726.4c.284.039.429.062.5.128a.286.286,0,0,1,.073.229c-.011.1-.117.2-.323.4l-1.974,1.924a.636.636,0,0,0-.112.123.355.355,0,0,0-.033.1.715.715,0,0,0,.017.167l.468,2.715c.045.29.073.429.028.513a.285.285,0,0,1-.2.145c-.095.017-.223-.05-.479-.184l-2.442-1.282a.567.567,0,0,0-.15-.073.372.372,0,0,0-.112,0,.567.567,0,0,0-.151.073l-2.442,1.282c-.257.134-.385.2-.479.184a.284.284,0,0,1-.2-.145c-.045-.083-.017-.223.028-.513l.468-2.715a.711.711,0,0,0,.017-.167.347.347,0,0,0-.033-.1.636.636,0,0,0-.112-.123l-1.974-1.924c-.206-.2-.312-.3-.323-.4a.284.284,0,0,1,.073-.229c.067-.067.212-.089.5-.128l2.727-.4a.608.608,0,0,0,.167-.033.248.248,0,0,0,.083-.067.552.552,0,0,0,.089-.145Z" transform="translate(-1961.824 -3547.871)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
        </svg> Navegue por marca`,
          attrs: { class: "navegue-por-marcas", href: "#manufacturer-area" },
        });

        painelEsq.append(naveguePorMarcaFixa);

        let filhos = catRoot.subcategorias || [];

        filhos.forEach((filhoOrig, idx) => {
          let filho = resolverDpt(filhoOrig);
          let catId = (filho.id || "idx-" + idx).toString();

          /* item da lista esquerda */
          let liEsq = wsMain.tools.createElm({
            type: "li",
            attrs: {
              class: "painel-cat-item",
              "data-cat-id": catId,
            },
          });
          let aEsq = wsMain.tools.createElm({
            type: "a",
            innerHTML: filho.nome,
            attrs: {
              href: filho.url || "javascript:;",
              title: filho.nome,
            },
          });
          liEsq.append(aEsq);
          painelEsq.append(liEsq);

          /* bloco do painel direito */
          let bloco = criarBloco(filho, idx === 0, catId);
          painelDir.append(bloco);

          /* primeiro item já vem ativo */
          if (idx === 0) liEsq.classList.add("ativo");

          /* hover troca o conteúdo do painel direito */
          liEsq.addEventListener("mouseenter", () => {
            painelEsq
              .querySelectorAll(".painel-cat-item.ativo")
              .forEach((e) => e.classList.remove("ativo"));
            painelDir
              .querySelectorAll(".painel-direito-bloco.ativo")
              .forEach((e) => e.classList.remove("ativo"));
            liEsq.classList.add("ativo");
            bloco.classList.add("ativo");
          });
        });

        painel.append(painelEsq);
      } else {
        /* categoria simples: bloco único com a própria categoria como título */
        let bloco = criarBloco(catRoot, true);
        painelDir.append(bloco);
      }

      painel.append(painelDir);
      return painel;
    }

    function createCatList(cat, n = 0) {
      if (
        cat.id != "allCats-menu" &&
        cat.tipo == "dpt" &&
        cat.registro &&
        cat.registro != 0
      ) {
        try {
          cat = search(returnJson.Categorias, cat.registro)[0];
        } catch (err) {
          return "";
        }
      }
      if (cat.tipo == "inst")
        wsMain.globalData.infoLoja.menuinstitucional.forEach((int) => {
          if (cat.registro == int.id) cat.url = int.url;
        });

      if (cat.registro == 0) {
        cat = {
          atual: false,
          id: "allCats-custom",
          nome: cat.nome,
          produtodestaque: false,
          subcategorias: JSON.parse(JSON.stringify(categorias)),
        };
      }

      let li = wsMain.tools.createElm({
        type: "li",
        attrs: {
          class: "dpt-" + n + " nav-menu-item",
          id: "departamento-" + cat.id,
        },
      });

      if (n == 0 && options.allCats && cat.id == "allCats-menu") {
        li.classList.add("dpt-all");
        li.style.display = "none";
      }

      if (options.mobile && n == 1 && cat.id == "allCats-menu") {
        return "";
      }

      let hiperLink = wsMain.tools.createElm({
        type: "a",
        innerHTML: cat.nome,
        attrs: {
          class: "nav-menu-hiperlink",
          title: cat.nome || "Todas as Categorias",
          href: cat.url || "javascript:;",
        },
      });

      li.append(hiperLink);

      let subCats = cat.subcategorias;
      /* [novo] painel duplo: dpt-0 em modo dropdown abre tudo em um único hover */
      if (
        subCats &&
        Array.isArray(subCats) &&
        subCats.length > 0 &&
        n == 0 &&
        options.dropDown == true
      ) {
        li.classList.add("hover", "dropdown");
        hiperLink.classList.add("dropdown", "has-sub");
        let comPainelEsquerdo =
          options.allCats == true && cat.id == "allCats-menu";
        li.append(createPainelDuplo(cat, comPainelEsquerdo));
        return li;
      }
      if (subCats && Array.isArray(subCats) && subCats.length > 0) {
        if (
          (options.hoverMode == false && options.dropDown != true) ||
          options.mobile
        ) {
          hiperLink.setAttribute("href", "javascript:;");
          hiperLink.setAttribute(
            "onclick",
            'wsMain.modules["categorias"].selectMode(this)',
          );
          hiperLink.classList.add("has-sub");

          if (subCats[0].holder != true) {
            subCats.unshift({
              nome: "Ver Tudo",
              holder: true,
              id: cat.id,
              url: cat.url,
            });
          }
        } else {
          li.classList.add("hover");
        }

        let ul = wsMain.tools.createElm({
          type: "ul",
          attrs: { class: "nav-menu-sub-list" },
        });
        let divHolder = wsMain.tools.createElm({
          type: "div",
          attrs: { class: n == 0 ? "nav-menu-main" : "nav-menu-sub-container" },
        });
        for (let i = 0; i < subCats.length; i++) {
          ul.append(createCatList(subCats[i], n + 1));
        }
        if (n != 0) {
          let titleList = createTitle(title, cat.url, cat.nome);
          if (options.dropDown != true) divHolder.append(titleList);
        }
        divHolder.append(ul);
        if (n > 0 && options.hoverMode != false) {
          hiperLink.classList.add("has-sub");
          let spanLink = wsMain.tools.createElm({
            type: "span",
            attrs: {
              "data-wsjs-icon": "arrow",
            },
          });
          hiperLink.append(spanLink);
          if (options.dropDown != true) {
            hiperLink.setAttribute("href", "javascript:;");
            hiperLink.addEventListener("click", (e) => {
              let subContainer = hiperLink.parentNode.querySelector(
                ".nav-menu-sub-container",
              );
              if (subContainer) subContainer.classList.add("active");
            });
          }
        }

        if (n == 0 && options.dropDown == true)
          divHolder.classList.add("dropdown");
        if (options.dropDown == true) hiperLink.classList.add("dropdown");

        if (n > 0 && options.dropDown != true) {
          divHolder.append(
            wsMain.tools.createElm({
              type: "div",
              attrs: {
                class: "nav-menu-overlay",
              },
            }),
          );
        }

        li.append(divHolder);

        if (options.dropDown == true) li.classList.add("dropdown");
      }

      if (
        subCats &&
        Array.isArray(subCats) &&
        subCats.length > 0 &&
        configs.megaMenu &&
        cat.produtodestaque &&
        options.megaMenu != false &&
        options.dropDown != true
      ) {
        let megaMenu = wsMain.tools.createElm({
          type: "div",
          attrs: {
            class: "nav-menu-megamenu-container",
          },
        });
        let img = wsMain.tools.createElm({
          type: "img",
          attrs: {
            class: "nav-menu-megamenu-item-image",
            src: cat.produtodestaque.imagem,
          },
        });
        let prodDestaqueName = wsMain.tools.createElm({
          type: "div",
          attrs: {
            class: "nav-menu-megamenu-item-nome-container",
          },
          innerHTML: "<p>" + cat.produtodestaque.nome + "</p>",
        });
        let prodDestaqueContainer = wsMain.tools.createElm({
          type: "a",
          attrs: {
            href: cat.produtodestaque.url,
            class: "nav-menu-megamenu-item",
          },
        });
        let imgHolder = wsMain.tools.createElm({
          type: "div",
          attrs: {
            class: "nav-menu-megamenu-item-image-container",
          },
        });

        let photowrap = "{photowrap}";
        let aspectRatio = "1/1";
        if (photowrap == "Quadrada") {
          aspectRatio = "1/1";
        }
        if (photowrap == "Vertical") {
          if (photo) photo = photo.replace("/PEQ_", "/MED_");
          console.log(photo);
          aspectRatio = "3/4";
        }
        if (photowrap == "Super Vertical") {
          if (photo) photo = photo.replace("/PEQ_", "/MED_");
          console.log(photo);
          aspectRatio = "2/3";
        }
        if (photowrap == "Horizontal") {
          aspectRatio = "4/3";
        }

        imgHolder.style.setProperty("aspect-ratio", aspectRatio);

        imgHolder.append(img);
        prodDestaqueContainer.append(imgHolder);
        prodDestaqueContainer.append(prodDestaqueName);
        megaMenu.append(prodDestaqueContainer);
        li.append(megaMenu);
      }

      return li;
    }

    for (let i = 0; i < arrCat.length; i++) {
      ulMain.append(createCatList(arrCat[i]));
    }

    if (arrCat.length == 0 && arrLvl == 0) {
      tag.remove();
    } else {
      divMain.append(ulMain);

      wsMain.tools.replaceSpanTag(divMain, tag);
      let maxWidth = ulMain.offsetWidth;

      ulMain
        .querySelectorAll(":scope .dpt-1 .nav-menu-hiperlink.dropdown")
        .forEach((elm) => {
          elm.addEventListener("mouseover", () => {
            let offset = elm.offsetTop;
            elm.nextSibling.style.top = offset + "px";
            elm.nextSibling.style.display = "block";
            setTimeout(() => {
              elm.nextSibling.style.opacity = "1";
            }, 1);
            setTimeout(() => {
              elm.nextSibling.style.top = offset + "px";
              elm.nextSibling.style.display = "block";
              setTimeout(() => {
                elm.nextSibling.style.opacity = "1";
              }, 1);
            }, 200);
          });

          elm.addEventListener("mouseout", () => {
            setTimeout(() => {
              elm.nextSibling.style.opacity = "";
              elm.nextSibling.style.display = "";
            }, 200);
          });
        });

      ulMain.addEventListener("mouseleave", () => {
        ulMain
          .querySelectorAll(".nav-menu-sub-container.active")
          .forEach((elm) => elm.classList.remove("active"));
        ulMain
          .querySelectorAll("li:not(.dpt-0) > .nav-menu-hiperlink.active")
          .forEach((elm) => elm.classList.remove("active"));
      });
      let menuItens = ulMain.querySelectorAll(".nav-header .dpt-0");

      function getWidth() {
        menuItens = ulMain.querySelectorAll(".nav-header .dpt-0");
        let width = 0,
          gap = getComputedStyle(ulMain).getPropertyValue("column-gap");
        gap = gap && gap != "normal" ? gap : 0;
        menuItens.forEach(
          (elm, i) =>
            (width +=
              elm.querySelector(":scope > a").offsetWidth +
              (i == menuItens.length - 1 ? 0 : parseInt(gap))),
        );
        return width;
      }

      let permanentCategories = options
        ? options["always-visible"]?.split(",").map((a) => a.trim()) || false
        : false;

      while (getWidth() > maxWidth) {
        try {
          ulMain.querySelector(".dpt-all").style.display = "";
        } catch (err) {}

        if (permanentCategories) {
          for (let p = menuItens.length - 1; p >= 0; p--) {
            let isEqual = false;

            permanentCategories.forEach(
              (pCategorie) =>
                (isEqual =
                  "departamento-" + pCategorie ==
                  menuItens[p].getAttribute("id")
                    ? true
                    : isEqual),
            );

            if (!isEqual) {
              menuItens[p].remove();
              break;
            }
          }
        } else {
          menuItens[menuItens.length - 1].remove();
        }
      }

      try {
        ulMain.querySelectorAll(":scope > li").forEach((elm) => {
          let menuMain = elm.querySelector(":scope > .nav-menu-main");
          let megaMenu = elm.querySelector(
            ":scope > .nav-menu-megamenu-container",
          );

          let offsetMenuMain = menuMain.getBoundingClientRect();
          let offsetMegaMenu = menuMain.getBoundingClientRect();

          if (megaMenu) {
            if (
              offsetMenuMain.left +
                menuMain.offsetWidth +
                megaMenu.offsetWidth +
                20 >
              window.innerWidth
            ) {
              elm.classList.add("alignToRight");
              elm.querySelector(":scope > .nav-menu-main").style.marginRight =
                "30rem";
            }
          } else {
            if (
              offsetMegaMenu.left + menuMain.offsetWidth + 20 >
              window.innerWidth
            ) {
              elm.classList.add("alignToRight");
            }
          }
        });
      } catch (err) {}

      /* alinha painel duplo à direita quando transbordaria a viewport */
      try {
        ulMain.querySelectorAll(":scope > li").forEach((elm) => {
          let painel = elm.querySelector(":scope > .nav-menu-painel.dropdown");
          if (!painel) return;

          let prevVisibility = painel.style.visibility;
          let prevDisplay = painel.style.display;
          painel.style.visibility = "hidden";
          painel.style.display = "flex";

          let liRect = elm.getBoundingClientRect();
          let painelWidth = painel.offsetWidth;

          if (liRect.left + painelWidth + 20 > window.innerWidth) {
            elm.classList.add("alignToRight");
          }

          painel.style.display = prevDisplay;
          painel.style.visibility = prevVisibility;
        });
      } catch (err) {}
    }

    return true;
  },
  selectMode(elm) {
    try {
      if (elm != elm.parentNode.querySelector(".active")) {
        elm.parentNode.parentNode
          .querySelector(".active")
          .classList.remove("active");
      }
    } catch (_) {}

    elm.classList.toggle("active");
  },
});
